//Material Ui
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import { Currency } from "../../../../helpers/currencyConvert";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "0.9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

export const createHeader = (data, textColor, sorts, sort, handleSort) => {
  return data.map((item, i) => (
    <React.Fragment key={i}>
      <TableCell
        align="center"
        sx={{ backgroundColor: "primary.main", color: textColor }}
        onClick={() => sorts[i] && handleSort(sorts[i])}
      >
        {`${item} ${sort.field === sorts[i] ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
      </TableCell>
    </React.Fragment>
  ));
};

export const createData = (data, options, id, i, dates) => {
  return (
    <TableRow
      key={id}
      sx={{
        "&:hover": { backgroundColor: "secondary.light" },
        backgroundColor: i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
      }}
    >
      {options.map((item, i) => (
        <React.Fragment key={i}>
          <TableCell sx={{ ...cellStyles }}>
            {["collection", "expired"].includes(item) ? (
              <Currency value={data[item] || 0} />
            ) : ["operationDate"].includes(item) ? (
              dates.formatDate(data[item])
            ) : (
              data[item]
            )}
          </TableCell>
        </React.Fragment>
      ))}
    </TableRow>
  );
};
